import createModel from 'utils/model'
import {create, customerCount, filterCustomerCount} from 'crm/services/tag-create-group'

export default createModel({
    namespace: 'crm_tagCreateGroupBuild',

    state: {},

    effects: {
        *create({payload}, {call}) {
            return yield call(create, payload)
        },
        *customerCount({payload}, {call}) {
            return yield call(customerCount, payload)
        },
        *filterCustomerCount({payload}, {call}) {
            return yield call(filterCustomerCount, payload)
        },
    },
    reducers: {},
})
